// extracted by mini-css-extract-plugin
export default {"loadimg":"Wrapper_loadimg__0Epmc","loadWindow":"Wrapper_loadWindow__rZD8N","windowLoad":"Wrapper_windowLoad__6-u-s","pageWrapper":"Wrapper_pageWrapper__TvJFA"};